import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import LinkEditor from '../../../components/Editor/LinkEditor';
import { getPageEditableMediaIds } from '../selectors';

interface LinkEditorOwnProps {
	page: number;
	id: string;
}

const mapStateToProps = (state: StoreState, { page, id }: LinkEditorOwnProps) => {
	const {
		editor: {
			editableLinks,
			activeItem,
			editPanel: { isDisplayed: isEditPanelDisplayed },
			spreadZoom,
		},
	} = state;

	const { linkData, isThemedItem } = editableLinks[page][id];
	const editableMediaIds = getPageEditableMediaIds(state, page);

	return {
		linkData,
		isActive: id === activeItem.id && page === activeItem.page,
		isEditPanelDisplayed,
		hasEditableImage: editableMediaIds.includes(id),
		isThemedItem,
		spreadZoom,
	};
};

export default connect(mapStateToProps)(LinkEditor);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/LinkEditor/index.tsx